<script>
  import ItemsA from "./ItemsA.js";
  import ItemsB from "./ItemsB.js";
  import ItemsC from "./ItemsC.js";
  import ItemsD from "./ItemsD.js";
  import ItemsE from "./ItemsE.js";
  import Item from "./Item.svelte";

  let activeTab = 0;

  let activeTile;
</script>

<div class="title">Sistema de Memoria Temático</div>

<div class="{activeTile ? '' : 'tile'} is-ancestor">
  <div class="{activeTile ? '' : 'tile'} is-vertical">
    <div class="{activeTile ? '' : 'tile'}">
      <div class="{activeTile ? '' : 'tile'} is-parent is-vertical">
        <article class="{activeTile ? '' : 'tile'} is-child notification is-primary {activeTile && activeTile !== 1 ? 'invisible' : ''}">
          {#if activeTile}
            <span class="x" on:click={() => activeTile = undefined}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </span>
          {/if}

          <p class="title {activeTile ? '' : 'cursor-pointer'}" on:click={() => activeTile = 1}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFF" viewBox="0 0 256 256"><path d="M247.63,39.89a8,8,0,0,0-7.52-7.52c-51.76-3-93.32,12.74-111.18,42.22-11.8,19.49-11.78,43.16-.16,65.74a71.34,71.34,0,0,0-14.17,27L98.33,151c7.82-16.33,7.52-33.35-1-47.49-13.2-21.79-43.67-33.47-81.5-31.25a8,8,0,0,0-7.52,7.52c-2.23,37.83,9.46,68.3,31.25,81.5A45.82,45.82,0,0,0,63.44,168,54.58,54.58,0,0,0,87,162.33l25,25V216a8,8,0,0,0,16,0V186.51a55.61,55.61,0,0,1,12.27-35,73.91,73.91,0,0,0,33.31,8.4,60.9,60.9,0,0,0,31.83-8.86C234.89,133.21,250.67,91.65,247.63,39.89ZM47.81,147.6C32.47,138.31,23.79,116.32,24,88c28.32-.24,50.31,8.47,59.6,23.81,4.85,8,5.64,17.33,2.46,26.94L61.65,114.34a8,8,0,0,0-11.31,11.31l24.41,24.41C65.14,153.24,55.82,152.45,47.81,147.6Zm149.31-10.22c-13.4,8.11-29.15,8.73-45.15,2l53.69-53.7a8,8,0,0,0-11.31-11.31L140.65,128c-6.76-16-6.15-31.76,2-45.15,13.94-23,47-35.82,89.33-34.83C232.94,90.34,220.14,123.44,197.12,137.38Z"></path></svg> Vivir la Nueva Vida
          </p>

          {#if activeTile}
            <div class="content">
              <div class="block">
                {#each ItemsA as { groupClass, group, number, theme, ref, text }}
                <Item
                  groupClass="{groupClass}"
                  group="{group}"
                  number="{number}"
                  theme="{theme}"
                  ref="{ref}"
                  text="{text.lbla}"
                />
                {/each}
              </div>
            </div>
          {/if}
        </article>
        <article class="tile is-child notification is-purple {activeTile && activeTile !== 2 ? 'invisible' : ''}">
          {#if activeTile}
            <span class="x" on:click={() => activeTile = undefined}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </span>
          {/if}

          <p class="title {activeTile ? '' : 'cursor-pointer'}" on:click={() => activeTile = 2}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000" viewBox="0 0 256 256"><path d="M240,120a48.05,48.05,0,0,0-48-48H152.2c-2.91-.17-53.62-3.74-101.91-44.24A16,16,0,0,0,24,40V200a16,16,0,0,0,26.29,12.25c37.77-31.68,77-40.76,93.71-43.3v31.72A16,16,0,0,0,151.12,214l11,7.33A16,16,0,0,0,186.5,212l11.77-44.36A48.07,48.07,0,0,0,240,120ZM40,199.93V40h0c42.81,35.91,86.63,45,104,47.24v65.48C126.65,155,82.84,164.07,40,199.93Zm131,8,0,.11-11-7.33V168h21.6ZM192,152H160V88h32a32,32,0,1,1,0,64Z"></path></svg> Proclamar a Cristo
          </p>

          {#if activeTile}
            <div class="content">
              <div class="block">
                {#each ItemsB as { groupClass, group, number, theme, ref, text }}
                <Item
                  groupClass="{groupClass}"
                  group="{group}"
                  number="{number}"
                  theme="{theme}"
                  ref="{ref}"
                  text="{text.lbla}"
                />
                {/each}
              </div>
            </div>
          {/if}
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child notification is-info {activeTile && activeTile !== 3 ? 'invisible' : ''}">
          {#if activeTile}
            <span class="x" on:click={() => activeTile = undefined}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </span>
          {/if}

          <p class="title {activeTile ? '' : 'cursor-pointer'}" on:click={() => activeTile = 3}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFF" viewBox="0 0 256 256"><path d="M224,48H160a40,40,0,0,0-32,16A40,40,0,0,0,96,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h64a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM96,192H32V64H96a24,24,0,0,1,24,24V200A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V88a24,24,0,0,1,24-24h64ZM160,88h40a8,8,0,0,1,0,16H160a8,8,0,0,1,0-16Zm48,40a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h40A8,8,0,0,1,208,128Zm0,32a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h40A8,8,0,0,1,208,160Z"></path></svg> Confiar en los Recursos de Dios
          </p>

          {#if activeTile}
            <div class="content">
              <div class="block">
                {#each ItemsC as { groupClass, group, number, theme, ref, text }}
                <Item
                  groupClass="{groupClass}"
                  group="{group}"
                  number="{number}"
                  theme="{theme}"
                  ref="{ref}"
                  text="{text.lbla}"
                />
                {/each}
              </div>
            </div>
          {/if}
        </article>
      </div>
    </div>
    <div class="tile is-parent">
        <article class="tile is-child notification is-pink {activeTile && activeTile !== 4 ? 'invisible' : ''}">
          {#if activeTile}
            <span class="x" on:click={() => activeTile = undefined}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </span>
          {/if}

          <p class="title {activeTile ? '' : 'cursor-pointer'}" on:click={() => activeTile = 4}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFF" viewBox="0 0 256 256"><path d="M200,72H160V32a16,16,0,0,0-16-16H112A16,16,0,0,0,96,32V72H56A16,16,0,0,0,40,88v32a16,16,0,0,0,16,16H96v88a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V136h40a16,16,0,0,0,16-16V88A16,16,0,0,0,200,72Zm0,48H160a16,16,0,0,0-16,16v88H112V136a16,16,0,0,0-16-16H56V88H96a16,16,0,0,0,16-16V32h32V72a16,16,0,0,0,16,16h40Z"></path></svg> Ser Discipulo de Cristo
          </p>

          {#if activeTile}
            <div class="content">
              <div class="block">
                {#each ItemsD as { groupClass, group, number, theme, ref, text }}
                <Item
                  groupClass="{groupClass}"
                  group="{group}"
                  number="{number}"
                  theme="{theme}"
                  ref="{ref}"
                  text="{text.lbla}"
                />
                {/each}
              </div>
            </div>
          {/if}
        </article>
    </div>
  </div>
  <div class="tile is-parent">
        <article class="tile is-child notification is-success {activeTile && activeTile !== 5 ? 'invisible' : ''}">
          {#if activeTile}
            <span class="x" on:click={() => activeTile = undefined}>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFFFFF" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
            </span>
          {/if}

          <p class="title {activeTile ? '' : 'cursor-pointer'}" on:click={() => activeTile = 5}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#FFF" viewBox="0 0 256 256"><path d="M198.1,62.6a76,76,0,0,0-140.2,0A72.27,72.27,0,0,0,16,127.8C15.89,166.62,47.36,199,86.14,200A71.68,71.68,0,0,0,120,192.49V232a8,8,0,0,0,16,0V192.49A71.45,71.45,0,0,0,168,200l1.86,0c38.78-1,70.25-33.36,70.14-72.18A72.26,72.26,0,0,0,198.1,62.6ZM169.45,184a55.61,55.61,0,0,1-32.52-9.4q-.47-.3-.93-.57V132.94l43.58-21.78a8,8,0,1,0-7.16-14.32L136,115.06V88a8,8,0,0,0-16,0v51.06L83.58,120.84a8,8,0,1,0-7.16,14.32L120,156.94V174q-.47.27-.93.57A55.7,55.7,0,0,1,86.55,184a56,56,0,0,1-22-106.86,15.9,15.9,0,0,0,8.05-8.33,60,60,0,0,1,110.7,0,15.9,15.9,0,0,0,8.05,8.33,56,56,0,0,1-22,106.86Z"></path></svg> Crecer en Semejanza a Cristo
          </p>

          {#if activeTile}
            <div class="content">
              <div class="block">
                {#each ItemsE as { groupClass, group, number, theme, ref, text }}
                <Item
                  groupClass="{groupClass}"
                  group="{group}"
                  number="{number}"
                  theme="{theme}"
                  ref="{ref}"
                  text="{text.lbla}"
                />
                {/each}
              </div>
            </div>
          {/if}
        </article>
  </div>
</div>

<style>
  @media (max-width: 600px) {
    .tile.is-parent {
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  .is-purple {
    background: #ae3ec9;
    color: #fff;
  }

  .is-pink {
    background: #d6336c;
    color: #fff;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .x {
    float: right;
    margin-right: -24px;
    cursor: pointer;
  }

  .invisible {
    display: none;
  }

  svg {
      fill: currentColor;
  }
</style>
